module.exports = __webpack_public_path__ + "img/car_sendai20.9c745a8a.jpg";